import { Component, OnInit } from "@angular/core";
import { ActionResult } from "../../../model/action-result";
import { MultiActionService } from "../../../services/multi-action.service";
import { Messages } from "../../../model/messages";
import { BehaviorSubject } from "rxjs";
import { TicketService } from "../../../services/ticket.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";

@Component({
  selector: "processing",
  templateUrl: "./processing.component.html",
  styleUrls: ["./processing.component.css"],
})
export class ProcessingComponent implements OnInit {
  actionResults: ActionResult[] = [];
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);

  constructor(
    public multiAction: MultiActionService,
    private ticketService: TicketService,
    private auth: AuthService,
    private router: Router,
    private nav: NavigationHelper
  ) {}

  ngOnInit() {
    this.multiAction.actionResults.subscribe((results) => {
      this.actionResults = results;
    });

    this.multiAction.processingCompleted.subscribe(() => {
      const token = this.auth.token;
      this.ticketService.search(token).subscribe((messages) => {
        const updatedTicket = this.ticketService.ticketData;
        this.ticketService._currentTicket.next(updatedTicket);
      });
    });

    this.multiAction.processTickets();
  }

  isSuccess(result: ActionResult): boolean {
    return result.messages.empty;
  }

  asObservableMessages(messages: Messages): BehaviorSubject<Messages> {
    return new BehaviorSubject<Messages>(messages);
  }
  get allTicketsSuccessful(): boolean {
    return (
      this.actionResults.length > 0 &&
      this.actionResults.every((result) => this.isSuccess(result))
    );
  }
  finish() {
    const pageId = this.ticketService.currentPage.value;

    this.router
      .navigate(["/tickets/-1", "result", "page", pageId])
      .then((success) => {});
  }
}
